<template>
  <div class="form-group mt-5">
    <div v-for="(item, i) in options" :key="i" class="form-check">
      <input
        ref="item"
        :type="config.InputType"
        :data-vv-as="config.ErrorMessage"
        v-validate="config.Validation"
        class="form-check-input"
        :id="'check' + id + i"
        :name="id"
        :value="item.Value"
        @change="update(i)"
        :checked="item.Value == value"
      />
      <label class="form-check-label" :for="'check' + id + i">
        <h4 v-if="item.Title">{{ item.Title }}</h4>
        <p v-if="item.SubTitle">{{ item.SubTitle }}</p>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['value', 'options', 'config', 'id'],
    methods: {
      update(i) {
        // check if valid
        this.$emit('input', this.$refs.item[i].value);
        this.$emit('getNewData');
      },
    },
  };
</script>
<style lang="scss" scoped>
  $padLeft: 24px;
  input {
    display: none;
  }
  label {
    position: relative;
    padding-left: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    &::after {
      position: absolute;
      width: 21px;
      height: 21px;
      border: 2px solid $blue60;
      border-radius: 50%;
      content: '';
      left: -$padLeft;
      top: 2px;
      .form-check-input:checked + & {
        border-color: $blue;
      }
    }
    &::before {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      content: '';
      left: -$padLeft + 7px;
      top: 9px;
      position: absolute;
      background-color: $blue;
      transform: scale(0);
      transition: 0.3s ease;
      .form-check-input:checked + & {
        transform: scale(1);
      }
    }
  }
</style>
